import SourceBox from './SourceBox'

export default SourceBox;



// WEBPACK FOOTER //
// ./src/components/SourceBox/index.js